import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from "@mui/material/Divider";
import {Stack} from "@mui/material";
import WorkDashboardCSFGrid from "./WorkDashboardCSF/WorkDashboardCSFGrid";
import WorkDashboardCDPGrid, {CDPcontext} from "./WorkDashboardCDP/WorkDashboardCDPGrid";
import WorkDashboardCSGrid from "./WorkDashboardCS/WorkDashboardCSGrid";
import {useContext, useEffect, useState} from "react";
import WorkDashboardStatsDBGrid from "./WorkDashboardStats/WorkDashboardStatsDBGrid";
import ContractStatusPieChart from "../WorkWelcome/WorkWelcomeCharts/ContractStatusPieChart";



export default function WorkDashboardFrame(props) {

    // this passing of the selected contract section id from the child component to this parent
    // is based on the approach at the bottom of https://stackoverflow.com/questions/38394015/how-to-pass-data-from-child-component-to-its-parent-in-reactjs
    const [contractSectionIdP, setContractSectionIdP] = useState([]);
    const [contractIdq, setContractIdq] = useState(props.contractIdq);
    const [contractName, setContractName] = useState(props.contractName);
    const [contractDescription, setContractDescription] = useState(props.contractDescription);
    const [showCDPVDrawerTop,setShowCDPVDrawerTop] = useState(false);
    const holyHell = useContext(CDPcontext);
    const [selectedCDPTop,setSelectedCDPTop] = useState([]);
    let contractId;

    useEffect(() => {
        if (props.contractIdq !== setContractIdq()) {
            setContractIdq(props.contractIdq);
            console.log("this is my contractId");
            console.log(props.contractIdq);
            console.log(contractIdq);
        };
        {
            setContractName(props.contractName);
            console.log("this is my contractName");
            console.log(props.contractName);
            console.log(contractName);
            console.log("this is my CDP");
            console.log(holyHell);
        }
        if (props.contractDescription !== setContractDescription()) {
            setContractDescription(props.contractDescription);
            console.log("this is my contractDescription");
            console.log(props.contractDescription);
            console.log(contractDescription);
        };
    }, [props.contractIdq]);



    const handleBackButton = () => {
        props.passContractGridVisible(true);
        props.passWorkDashboardVisible(false);
    }

    return (


        <div>

            {/*<WorkDashboardStatsDBGrid/>*/}

{/*<WorkQueueProdCDPGrid/>*/}
            {/*<Container*/}
            {/*    sx={{*/}

            {/*       height: 30,*/}
            {/*        paddingLeft: 3*/}
            {/*    }}>*/}
            {/*    <h4                       component={Link} to={"/Participations"}>^</h4>*/}
            {/*</Container>*/}
            {true && < Stack direction="row" spacing={2}>


                <Box
                    sx={{

                        width: 600,
                        height: 800,
                        flexGrow: 2,
                        backgroundColor: 'primary.white',
                        '&:hover': {
                            backgroundColor: 'primary.white',
                            opacity: [0.9, 0.8, 0.7],
                        },
                    }}
                >

                    {/*this pass... = is part of having the child component pass the data with its exported function*/}
                    <WorkDashboardCSGrid
                        passContractSectionIdP={setContractSectionIdP}
                        contractIdq = {contractIdq}
                        // contractId = {contractId}

                    />

                </Box>

                <Box
                    sx={{
                        width: 800,
                        height: 800,
                        flexGrow: 2,
                        // position: "right",
                        // justifySelf: "right",
                        backgroundColor: 'primary.white',
                        '&:hover': {
                            backgroundColor: 'primary.white',
                            opacity: [0.9, 0.8, 0.7],
                        },
                    }}
                >

                    <WorkDashboardCSFGrid selectedSection = {contractSectionIdP}/>
                    <Divider/>
                    <Box sx={{height: 40}} />

                    <WorkDashboardCDPGrid

                        selectedSection = {contractSectionIdP}

                        passSelectedCDP = {setSelectedCDPTop}
                        passShowCDPVDrawer = {setShowCDPVDrawerTop}
                    />
                </Box>



            </Stack>}


        </div>

    );

}
